// Utility per link telefono / WhatsApp a partire da un numero "sporco"
// (con spazi, +, trattini). Default paese Italia (+39).

const DEFAULT_CC = '39';

/** Solo cifre, tenta di normalizzare al formato internazionale senza '+'. */
export function normalizePhone(raw: string | null | undefined): string | null {
    if (!raw) return null;
    let d = raw.replace(/\D/g, '');
    if (!d) return null;
    // 00xx... prefisso internazionale -> togli 00
    if (d.startsWith('00')) d = d.slice(2);
    // già con prefisso Italia
    if (d.startsWith(DEFAULT_CC) && d.length >= 11) return d;
    // numero nazionale (mobile 3xx o fisso 0xx) -> anteponi prefisso paese
    return DEFAULT_CC + d;
}

/** URL wa.me per aprire la chat WhatsApp. null se numero non valido. */
export function whatsappUrl(raw: string | null | undefined, text?: string): string | null {
    const n = normalizePhone(raw);
    if (!n) return null;
    const q = text ? `?text=${encodeURIComponent(text)}` : '';
    return `https://wa.me/${n}${q}`;
}

/** URL tel: per la chiamata. */
export function telUrl(raw: string | null | undefined): string | null {
    if (!raw) return null;
    const cleaned = raw.replace(/[^\d+]/g, '');
    return cleaned ? `tel:${cleaned}` : null;
}
